import Vue from 'vue'
import { ToolboxRegistry, DialogRegistry, FadeLoaderComponent, install } from '@naffto/vuetify-helpers'
import GisFadeLoader from '@/components/base/FadeLoader'
import DefaultToolbox from '@/components/toolbox/Default'
import DefaultDialog from '@/components/dialog/Default'
import GalleryDialog from '@/components/dialog/Gallery'
import router from './vue-router'
import store from '@/store/index'
import vuetify from '@/plugins/vuetify'

ToolboxRegistry.register('default', DefaultToolbox)
DialogRegistry.register('default', DefaultDialog)
DialogRegistry.register('gallery', GalleryDialog)

Vue.use(install, {
  vuetify,
  alert: {
    offset: 30,
    width: 400,
    position: 'bottom center',
    duration: 4500
  },
  dialog: {
    registry: {
      gallery: 'gallery'
    },
    open: {
      dialogOptions: {
        width: 500,
        persistent: true
      }
    },
    delete: {
      contentComponent: () => import('@/components/dialog/content/Delete'),
      dialogOptions: {
        width: 500,
        persistent: true
      }
    },
    gallery: {
      dialogOptions: {
        persistent: true
      }
    }
  },
  toolbox: {
    registry: {
      openStack: 'default'
    },
    open: {
      vueInstance: {
        vuetify,
        store,
        router
      },
      registry: {
        closeAllToolboxes: true
      },
      dialogOptions: {
        width: 350,
        persistent: true
      }
    },
    openStack: {
      vueInstance: {
        vuetify,
        store,
        router
      },
      dialogOptions: {
        width: 350,
        persistent: true
      }
    }
  },
  fadeLoader: {
    injectMixin: true
  },
  theme: {
    primary: '#FF0000',
    secondary: '#FF0000',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

// helper loader überschreiben
Vue.component(FadeLoaderComponent.name, GisFadeLoader)
